import $ from "jquery";
import cookie from "js-cookie";
import Marionette from "backbone.marionette";

import { EVENT_ENTITY } from "lib/constants";

import events from "../events";
import component from "../components";
import util from "../util";
import { handleDuplicateUser } from "./util";

export default Marionette.View.extend({
    template: false,
    ui: {
        positions: "[name=positions]",
        positionError: "#position-error",
        regBtn: ".btn-primary",
    },
    events: {
        "click @ui.regBtn": "onSubmit",
    },
    serializeData() {
        return {};
    },
    onRender() {
        // User is logged in
        if (window.authUser) {
            return;
        }

        // Suspect they have a login
        if (util.shouldShowLogin()) {
            this.view = new component.LoginView({
                el: "#event-sign-up",
            });
        } else {
            this.view = new component.SignupView({
                el: "#event-sign-up",
                showPhone: this.isHiringEvent(),
                showPassword: !this.isHiringEvent(),
            });
        }
        this.view.render();
    },
    isHiringEvent() {
        return window.wsEvent.entity_type === EVENT_ENTITY.COMPANY;
    },
    getPositions() {
        return this.ui.positions
            .filter(":checked")
            .map((idx, el) => Number(el.value))
            .toArray()
            .join(",");
    },
    onSubmit() {
        if (this.isHiringEvent()) {
            this.onHiringEventSubmit();
        } else {
            this.onTrainingEventSubmit();
        }
    },
    onHiringEventSubmit() {
        let data = {};

        data.positions = this.getPositions();

        if (data.positions) {
            this.ui.positionError.hide();
        } else {
            this.ui.positionError.fadeIn("fast");
            return;
        }

        this.ui.regBtn.loading(true);

        // User is not logged in and we displayed a login or signup
        if (this.view) {
            // Login and then register for hiring event
            if (util.shouldShowLogin()) {
                const promise = this.view.login();
                if (promise) {
                    promise
                        .done(() => {
                            this.registerHiringEvent(data);
                        })
                        .fail(() => {
                            events.track("HIRING_EVENT", "login_failed");
                            this.ui.regBtn.loading(false);
                        });
                }
                return;
            }

            data = {
                ...this.view.getData(),
                ...data,
            };
        }

        // Logged in or Signup - user is created within POST to /app
        this.registerHiringEvent(data);
    },
    onTrainingEventSubmit() {
        this.ui.regBtn.loading(true);

        // Logged in, just register for training event
        if (!this.view) {
            this.registerTrainingEvent();
            return;
        }

        // Login and then register for training event
        if (util.shouldShowLogin()) {
            const promise = this.view.login();
            if (promise) {
                promise
                    .done(() => {
                        this.registerTrainingEvent();
                    })
                    .fail(() => {
                        events.track(this.eventType, "login_failed");
                        this.ui.regBtn.loading(false);
                    });
            } else {
                this.ui.regBtn.loading(false);
            }
            return;
        }

        /**
         * Signup and then register for training event
         * Hiring events create user with POST to /app, but must have explicit signup here
         */
        const promise = this.view.submit();
        if (promise) {
            promise
                .done(() => {
                    setTimeout(() => {
                        this.registerTrainingEvent();
                    }, 0);
                })
                .fail(() => {
                    this.ui.regBtn.loading(false);
                });
        } else {
            this.ui.regBtn.loading(false);
        }
    },
    registerHiringEvent(data) {
        const search = cookie.get("search");
        if (search && search.length > 0) {
            data.search = search;
        }

        const utm = cookie.get("utm");
        if (utm && utm.length > 0) {
            data.utm = utm;
        }

        data.hiring_event = window.wsEvent.id;

        $.ajax({
            type: "POST",
            url: "/app/start?_st=her",
            data: JSON.stringify(data),
            dataType: "json",
            contentType: "application/json",
        })
            .done(() => {
                data.positions.split(",").forEach((p) => {
                    events.track("HIRING_EVENT", `register_${p.id}`);
                });

                setTimeout(() => {
                    window.location.href = `${window.wsEvent.url}?p=${data.positions}`;
                }, 0);
            })
            .fail((error) => {
                events.track("HIRING_EVENT", "register_failed");
                this.ui.regBtn.loading(false);

                if (!handleDuplicateUser(error)) {
                    setTimeout(() => {
                        util.showToast(
                            "Your registration could not be submitted. Please check " +
                                "your internet connection and try again.",
                        );
                    }, 150);
                }
            });
    },
    registerTrainingEvent() {
        const data = {};

        const utm = cookie.get("utm");
        if (utm && utm.length > 0) {
            data.utm = utm;
        }

        $.ajax({
            type: "POST",
            url: `${window.wsEvent.url}register`,
            data: JSON.stringify(data),
            dataType: "json",
            contentType: "application/json",
        })
            .done(() => {
                events.track("TRAINING_EVENT", `register_${window.wsEvent.id}`);
                setTimeout(() => {
                    window.location.href = window.wsEvent.url;
                }, 0);
            })
            .fail(() => {
                events.track("TRAINING_EVENT", "register_failed");
                this.ui.regBtn.loading(false);

                setTimeout(() => {
                    util.showToast(
                        "Your registration could not be submitted. Please check " +
                            "your internet connection and try again.",
                    );
                }, 150);
            });
    },
});
